import React from 'react'

export default function Footer() {
    return (
        <div>
           this is a footer 
        </div>
    )
}
